import router from '@/router'
import store from '@/store'

export default {
  async setCurrentUserAndProjectClaims () {
    await store.dispatch('season/loadSeasons')
    await store.dispatch('season/setCurrentSeason')
    await store.dispatch('project/loadAllProjects')
    await store.dispatch('project/setCurrentProject')
    const currentProjectId = store.state.project.currentId
    await store.dispatch('user/loadCurrentUserAndProjectClaims', currentProjectId)
  },

  isRouteAvailableForCurrentUserAndProject (routeName, currentUser, currentUserAndProjectClaims) {
    const route = router.resolve({ name: routeName }).route
    if (!route) return

    const routeClaim = route.meta?.claim
    const routeChildrenClaims = route.meta?.childrenClaims

    if (!routeClaim && !routeChildrenClaims) {
      return true
    }

    if (routeChildrenClaims?.length) {
      let returnResult = false

      const notNullishChildrenClaims = routeChildrenClaims.filter(claim => {
        if (currentUserAndProjectClaims && currentUserAndProjectClaims.hasOwnProperty(claim) && currentUserAndProjectClaims[claim] !== null) {
          return true
        }
      })

      if (notNullishChildrenClaims?.length) {
        route.meta.redirectTo = notNullishChildrenClaims[0].replace('Claim', '')
        returnResult = true
      }

      return returnResult
    } else {
      if (currentUserAndProjectClaims && currentUserAndProjectClaims.hasOwnProperty(routeClaim) && currentUserAndProjectClaims[routeClaim] !== null) {
        return true
      }
    }

    return false
  }
}
